import {
  BUDGET_PAY_COMPARISON_TYPES,
  BUDGET_LEASE_COMPARISON_TYPES
} from '../../utils/constants';

export default function () {
  return {
    disableNavigation: false,
    budgetComparisonView: BUDGET_PAY_COMPARISON_TYPES.payment.value,
    budgetLeaseTypeView: BUDGET_LEASE_COMPARISON_TYPES.salarySacrifice.value,
    showFinanceCalculation: false
  };
}
